import React from 'react';
import PageTitle from '../PageTitle';
import $ from 'jquery';
import renderHTML from 'react-render-html';
import { doRequest } from '../../helper';
import { constants } from '../../Bootstrap';

import AWS from 'aws-sdk';

export default class AddInfographics extends React.Component {
    constructor() {
        super();
        var now = Date.now();
        this.state = {
            video: null,
            frame: <img />,
            canvasKey: "sampark/inforgraphic_" + now + '.jpg',
            bucketUrl: "https://s3.ap-south-1.amazonaws.com/js-sdk-bucket/"

        }
        this.getYoutube = this.getYoutube.bind( this );
        this.saveInfographics = this.saveInfographics.bind( this );

        //Initialize the Amazon Cognito credentials provider
        AWS.config.region = 'ap-south-1'; // Region
        AWS.config.credentials = new AWS.CognitoIdentityCredentials( {
            IdentityPoolId: 'ap-south-1:84027705-475d-4ca1-bac8-b2eb7407ae9f',
        } );
        this.bucketname = 'js-sdk-bucket';
        this.bucket = new AWS.S3( {
            params: {
                Bucket: this.bucketname
            }
        } );

        this.readURL = this.readURL.bind( this );

    }
    uploadToS3( file, type, bucket, callback ) {


        var objKey = null;
        if ( type == "canvas" ) {
            objKey = this.state.canvasKey;
        }
        var params = {
            Key: objKey,
            ContentType: file.type,
            Body: file,
            ACL: 'public-read'
        };
        if ( !callback ) {
            callback = ( err, data ) => {

            }
        }
        bucket.putObject( params, callback );

    }
    getYoutube( event ) {
        var ref = this;
        var url = event.target.value;
        $.ajax( {
            url: 'https://query.yahooapis.com/v1/public/yql',
            data: {
                q: "select * from json where url ='http://www.youtube.com/oembed?url=" + url + "&format=json'",
                format: "json"
            },
            dataType: "jsonp",
            success: function( data ) {
                if ( data.query && data.query.results ) {
                    var video = data.query.results.json;
                    $( "#youtubeVideoTitle" ).val( video.title );
                    ref.setState( { "frame": null, "image": null, "video": video } );
                }
            },
            error: function( result ) {
                alert( "Sorry no data found." );
            }
        } );

    }
    readURL( input ) {
        var ref = this;
        //reset
        if ( input.files && input.files[0] ) {
            var reader = new FileReader();

            reader.onload = function( e ) {
                var img = <img src={e.target.result} style={{ "width": "100%" }} />;
                ref.setState( { "video": null, "frame": img, "image": input.files[0] } );
            }

            reader.readAsDataURL( input.files[0] );
        }
    }


    saveInfographics() {
        var ref = this;
        var title = this.title.value;
        var data = {};
        if ( $.trim( title ) != "" && this.state.video ) {

            data['video_path'] = this.url.value;
            data['type'] = 'video';
            data['thumbnail_url'] = this.state.video.thumbnail_url;

        } else if ( $.trim( title ) != "" && this.state.image ) {

            ref.uploadToS3( this.state.image, 'canvas', ref.bucket, function() {
                alert( "Image inforgraphic updated" );
            } );
            data['image_path'] = this.state.bucketUrl + this.state.canvasKey;
            data['type'] = 'image';
        }
        else {
            return false;
        }
        data['title'] = title;
        data['status'] = 'enabled';

        var proceed = true;
        if ( $.trim( this.description.value ) == "" ) {
            proceed = window.confirm( "Do you want to save video without description ?" );
        } else {
            data['description'] = this.description.value;
        }
        
        data["category"] = this.category.value;
        data["locale"] = this.locale.value;
        
        if ( proceed ) {

            $( ".loader" ).show();
            var payload = {
                "action": "save-infographic",
                "module": "Sampark",
                "model": "Infographic",
                "data": data
            }

            var request = doRequest( 'cms-operations', payload, true );

            request.addEventListener( "load", function() {

                $( ".loader" ).hide();
                var response = this.responseText;
                try {
                    response = JSON.parse( response );
                    if ( response._resultflag && response._resultflag == 1 ) {
                        var now = Date.now();
                        alert( 'Infographics Saved' )
                        ref.title.value = '';
                        ref.description.value = '';
                        ref.url.value = '';
                        ref.setState( { canvasKey: "sampark/inforgraphic_" + now + '.jpg' } )

                    }
                } catch ( ex ) {
                    alert( 'Server Error' )

                }

            } );

        }
    }



    render() {
        var video = this.state.video;
        console.log( this.state );
        return (
            <div>
                <PageTitle title="Sampark Abhiyan" bread="Sampark Abhiyan / Add Infographics" />
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins">
                                <div className="ibox-title">
                                    <h5>Add Image / Youtube Video Link<small> New Infographics</small></h5>
                                    <div className="ibox-tools">
                                        <a className="collapse-link">
                                            <i className="fa fa-chevron-up"></i>
                                        </a>

                                    </div>
                                </div>
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-sm-6 b-r">

                                            <div className="form-group"><label>Youtube Video Link</label> <input ref={( url ) => { this.url = url }} onChange={this.getYoutube} type="text" placeholder="Enter youtube link" className="form-control" /></div>
                                            OR<br /><br />
                                            <div className="form-group"><label>Infographics Image</label> <input onChange={( file ) => { this.readURL( file.target ) }} ref={( image ) => { this.image = image }} type="file" placeholder="Select Image" className="form-control" /></div>
                                            <div  className="form-group"><label>Select Category</label>
                                                <select ref={( category ) => { this.category = category }} className={"category_select form-control"} >
                                                    <option value="">--Category--</option>
                                                    {constants.categories.map(( category ) => {
                                                        return ( <option value={category}>{category}</option> )
                                                    } )}
                                                </select>
                                            </div>
                                            <div className="form-group"><label>Select Language</label>
                                                <select ref={( locale ) => { this.locale = locale }}  className={"language_select form-control"} >
                                                    <option value="">--Language--</option>
                                                    {constants.languages.map(( language ) => {
                                                        return ( <option value={language}>{language}</option> )
                                                    } )}
                                                </select>

                                            </div>
                                            <div className="form-group"><label>Title</label> <input ref={( title ) => { this.title = title }} id="youtubeVideoTitle" type="test" placeholder="Video Title" className="form-control" /></div>
                                            <div className="form-group"><label>Description</label> <textarea ref={( description ) => { this.description = description }} placeholder="Description" className="form-control" ></textarea></div>
                                            <div>
                                                <button className="btn btn-sm btn-primary pull-right m-t-n-xs" type="submit" onClick={this.saveInfographics}>
                                                    <strong>Save Infographics</strong></button>

                                            </div>

                                        </div>


                                        {video ?
                                            <div className="col-sm-6"><p className="text-center">
                                                {renderHTML( video.html )}

                                            </p> </div> : ""}
                                        {this.state.frame ?
                                            <div className="col-sm-6"><p className="text-center">
                                                {this.state.frame}

                                            </p> </div> : ""}



                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div > );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Sampark/AddInfographics.jsx